import { motion } from 'framer-motion';
import { Seo } from '@/components/Seo';

export const Terms = () => {
    return (
        <div data-testid="terms-page">
            <Seo
                title="Terms & Conditions | CatchingOn"
                description="The terms and conditions for using the CatchingOn website and services."
                path="/terms"
            />
            <section className="pt-32 pb-20 bg-brand-periwinkle min-h-screen px-6 md:px-12">
                <div className="max-w-3xl mx-auto">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        <p className="text-sm font-bold tracking-widest text-black/60 mb-6">LEGAL</p>
                        <h1 className="text-4xl sm:text-5xl font-black text-black leading-tight mb-6">
                            Terms of Service
                        </h1>
                        <p className="text-black/60 mb-12">
                            Last updated: 14 March 2026
                        </p>

                        <div className="space-y-10 text-black/80">
                            <section>
                                <h2 className="text-2xl font-black text-black mb-3">1. About Us</h2>
                                <p>
                                    CatchingOn is a freelance marketing business operated by Ellie.
                                    This website is built and hosted by Dockside Design.
                                    You can contact us at{' '}
                                    <a href="mailto:ellie@catchingon.co.uk" className="text-black font-bold underline hover:text-brand-lime transition-colors">
                                        ellie@catchingon.co.uk
                                    </a>.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-2xl font-black text-black mb-3">2. Use of This Website</h2>
                                <p className="mb-3">
                                    By accessing and using this website, you agree to these Terms of Service.
                                    If you do not agree, please do not use the site.
                                </p>
                                <p>
                                    This website is provided for informational purposes and to allow you to enquire
                                    about our marketing services. You agree to use the site lawfully and not to
                                    misuse any features, including contact forms and email subscription.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-2xl font-black text-black mb-3">3. Services</h2>
                                <p className="mb-3">
                                    We offer marketing and communications services as described on our website.
                                    All descriptions are for guidance only and do not constitute a binding offer.
                                </p>
                                <p>
                                    A formal agreement will be made separately before any paid work begins.
                                    Project scope, timeline, and payment terms will be agreed in writing between both parties.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-2xl font-black text-black mb-3">4. Intellectual Property</h2>
                                <p className="mb-3">
                                    All content on this website — including text, images, logos, and design — is
                                    owned by CatchingOn or used with permission. You may not reproduce, distribute,
                                    or use any content without our prior written consent.
                                </p>
                                <p>
                                    For client projects, intellectual property ownership will be specified in the
                                    individual project agreement.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-2xl font-black text-black mb-3">5. Limitation of Liability</h2>
                                <p className="mb-3">
                                    This website is provided "as is" without warranties of any kind, express or implied.
                                    We do not guarantee that the website will be uninterrupted, error-free, or free of viruses.
                                </p>
                                <p>
                                    To the fullest extent permitted by law, CatchingOn shall not be liable for any indirect,
                                    incidental, or consequential damages arising from your use of this website.
                                    Nothing in these terms excludes liability for death, personal injury caused by negligence,
                                    or fraud.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-2xl font-black text-black mb-3">6. External Links</h2>
                                <p>
                                    This website may contain links to third-party websites. We are not responsible for
                                    the content, privacy practices, or availability of those sites.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-2xl font-black text-black mb-3">7. Privacy</h2>
                                <p>
                                    Your use of this website is also governed by our{' '}
                                    <a href="/privacy" className="text-black font-bold underline hover:text-brand-lime transition-colors">
                                        Privacy Policy
                                    </a>,
                                    which explains how we collect and use your personal data.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-2xl font-black text-black mb-3">8. Governing Law</h2>
                                <p>
                                    These terms are governed by the laws of England and Wales. Any disputes will be subject
                                    to the exclusive jurisdiction of the courts of England and Wales.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-2xl font-black text-black mb-3">9. Changes to These Terms</h2>
                                <p>
                                    We may update these terms from time to time. Any changes will be posted on this page
                                    with an updated date. Continued use of the website after changes constitutes acceptance
                                    of the revised terms.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-2xl font-black text-black mb-3">10. Contact</h2>
                                <p>
                                    If you have any questions about these terms, contact us at{' '}
                                    <a href="mailto:ellie@catchingon.co.uk" className="text-black font-bold underline hover:text-brand-lime transition-colors">
                                        ellie@catchingon.co.uk
                                    </a>.
                                </p>
                            </section>
                        </div>
                    </motion.div>
                </div>
            </section>
        </div>
    );
};

export default Terms;
